export const CREDIT_CARD_PAYMENT_GATEWAY_ID = 2;
